const INGREDIENTS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: [],
  latestEvent: undefined,
  data: [],
  isDirty: false,
  dataForRenaming: undefined,
  mainTreeExpandedKeys: [],
  supportingTreeExpandedKeys: [],
  isImageDetailsLoading: false,
  imageDetailsError: undefined,
}

export default INGREDIENTS_INITIAL_STATE
